import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/common/app.constants';
import { LoginService } from './login.service';
import { environment } from 'src/environments/environment';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  isHandset = false;
  loginForm: FormGroup;
  userId: string = "";
  password: string = "";
  selectedUser: string = "HQ";
  ShopList: any[] = []; // Your full list of shops
  filteredShops: any[] = []; // Filtered list for autocomplete
  isShopVisible: boolean;
  version: string;
  buildNo: any;
  isDisabled = true;


  constructor(private builder: FormBuilder,
    private router: Router, private loginService: LoginService,
    private snackBarService: SnackBarService,
    private breakpointObserver: BreakpointObserver,
    private permissionService: PermissionService
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      this.isHandset = state.matches;
    });
    this.isShopVisible = false;
    sessionStorage.clear();
    this.loginForm = this.builder.group({
      user_id: this.builder.control('', Validators.required),
      password: this.builder.control('', Validators.required),
      user_type: this.builder.control('', Validators.required),
      shop_id: this.builder.control('')
    });
    this.version = environment.version;
    this.buildNo = environment.buildNo;

  }

  ngOnInit(): void {
    this.authenticate();
    this.filteredShops = this.ShopList.slice();
    this.loginForm = this.builder.group({
      user_id: this.builder.control('', Validators.required),
      password: this.builder.control('', Validators.required),
      user_type: this.builder.control('', Validators.required),
      shop_id: this.builder.control('', [this.shopValidator.bind(this)])
    });

    // Restore login details from localStorage
    const savedLogin = localStorage.getItem('loginDetails');
    if (savedLogin) {
      const { user_id, user_type, shop_id } = JSON.parse(savedLogin);
      this.loginForm.patchValue({ user_id, user_type, shop_id: user_type === 'SHOP' ? shop_id : '' });
      this.selectedUser = user_type || 'HQ';
      this.isShopVisible = this.selectedUser === 'SHOP';
      this.isDisabled = this.selectedUser !== 'SHOP';
      // If HQ, clear shop_id field to avoid validation issues
      if (this.selectedUser !== 'SHOP') {
        this.loginForm.get('shop_id')?.setValue('');
      }
    }
  }

  /**
 * list active shops
 * 
 */
  getShopList() {
    this.loginService.getShopList().subscribe(
      (resp: any) => {
        if (resp.status == 'SUCCESS') {
          this.ShopList = resp.data.shops;
          // Patch shop_id from localStorage to the correct shop object
          const savedLogin = localStorage.getItem('loginDetails');
          if (savedLogin) {
            const { user_type, shop_id } = JSON.parse(savedLogin);
            if (user_type === 'SHOP' && shop_id) {
              // Try to find shop by id or name
              let shopObj = this.ShopList.find(shop => shop.id === shop_id || shop.name === shop_id);
              if (!shopObj && typeof shop_id === 'object' && shop_id.id) {
                shopObj = this.ShopList.find(shop => shop.id === shop_id.id);
              }
              if (shopObj) {
                this.loginForm.get('shop_id')?.setValue(shopObj);
              }
            }
          }
        } else {
          // this.snackBarService.error(resp.message);
          let snackBarData: SnackBarData = {
            title: "Failed",
            message: resp.message,
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      }


    );

  }

  /**
   * Validate the application credentials and navigate to user login
   */
  authenticate() {

    let authData = {
      user_name: environment.userId,
      password: environment.password,
      apikey: environment.appKey
    };

    this.loginService.authenticate(authData).subscribe(
      response => {
        if (response.status == 'SUCCESS') {
          let token = response.token;
          sessionStorage.setItem(AppConstants.SESSION_VAR_TOKEN, token);
          this.getShopList();
        } else {
          let snackBarData: SnackBarData = {
            title: "Failed",
            message: response.message,
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
    this.version = environment.version;
    this.buildNo = environment.buildNo;

  }

  /**
   * Validate the user credentials and navigate to dashboard
   */
  proceedUserLogin() {
    const formValue = this.loginForm.value;
    let shop_id = formValue.shop_id;

    // If shop_id is an object, extract its id
    if (shop_id && typeof shop_id === 'object') {
      shop_id = shop_id.id;
    }

    // Save login details to localStorage (excluding password)
    localStorage.setItem('loginDetails', JSON.stringify({
      user_id: formValue.user_id,
      user_type: formValue.user_type,
      shop_id: shop_id,
    }));

    // Build payload with only the shop id
    const payload = {

      user_id: formValue.user_id,
      user_type: formValue.user_type,
      shop_id: shop_id,
      password: formValue.password

    };

    // Send payload to backend
    let loginData = {};
    //console.log(this.loginForm);
    // if (this.selectedUser != 'SHOP') {
    //   this.loginForm.get('shop_id').clearValidators();
    //   this.loginForm.get('shop_id').updateValueAndValidity();
    // } else {
    //   this.loginForm.get('shop_id').setValidators(Validators.required);
    //   this.loginForm.get('shop_id').setValidators(Validators.required);
    // }
    if (this.loginForm.valid) {
      if (this.selectedUser != 'SHOP') {
        loginData = {
          user_name: this.loginForm.get("user_id")?.value,
          password: this.loginForm.get("password")?.value,
          user_type: this.loginForm.get("user_type")?.value,
          shop_id: 0
        };
      } else {
        if (shop_id) {
          loginData = {
            user_name: this.loginForm.get("user_id")?.value,
            password: this.loginForm.get("password")?.value,
            user_type: this.loginForm.get("user_type")?.value,
            shop_id: shop_id
          };

        } else {
          let snackBarData: SnackBarData = {
            title: "Login Failed.",
            message: "Please select a shop.",
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          return;
        }


      }
      // console.log(loginData);

      this.loginService.userLogin(loginData).subscribe(
        response => {
          if (response.status == 'SUCCESS') {
            let curUser = response.data;
            let token = response.token;
            curUser = this.permissionService.validatePermission(curUser);
            sessionStorage.setItem(AppConstants.SESSION_VAR_USER, JSON.stringify(curUser));
            sessionStorage.setItem(AppConstants.SESSION_VAR_TOKEN, token);
            if (response.data.user_type == "HQ") {
              this.router.navigate(['/dashboard-hq']);
            } else if (response.data.user_type == "SHOP") {
              this.router.navigate(['/dashboard-shop']);
            } else if (response.data.user_type == "AREA_MANAGER") {
              this.router.navigate(['/dashboard-area']);
              // setTimeout(() => window.location.reload(), 100); // Give router time to navigate before reload
            }
          } else {
            let snackBarData: SnackBarData = {
              title: "Login Failed.",
              message: response.message,
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        }
      );
    }
  }



  onUserTypeChange() {
    this.isShopVisible = this.selectedUser === 'SHOP';
    this.isDisabled = this.selectedUser !== 'SHOP'; // Disable when not 'SHOP'
    if (!this.isShopVisible) {
      this.loginForm.get('shop_id')?.setValue('');
    }
  }

  filterShops() {
    const value = this.loginForm.get('shop_id')?.value;
    const filterValue = typeof value === 'string' ? value.toLowerCase() : (value?.name?.toLowerCase() || '');
    this.filteredShops = this.ShopList.filter(shop =>
      shop.name.toLowerCase().includes(filterValue)
    );
  }

  displayShopName(shop: any): string {
    return shop && shop.name ? shop.name : '';
  }

  clearShop() {
    this.loginForm.get('shop_id')?.setValue('');
    this.filteredShops = this.ShopList.slice();
  }

  shopValidator(control: AbstractControl) {
    if (!control.value) return null;
    // If value is an object and exists in ShopList, it's valid
    if (typeof control.value === 'object' && this.ShopList.some(shop => shop.id === control.value.id)) {
      return null;
    }
    // If value is a string, check if it matches any shop name
    if (typeof control.value === 'string' && this.ShopList.some(shop => shop.name === control.value)) {
      return null;
    }
    return { invalidShop: true };
  }
}
